export default `
mutation DeleteServiceProviderUser($userId: AWSEmail!, $serviceProviderId: ID!){
  deleteServiceProviderUser(userId: $userId, serviceProviderId: $serviceProviderId) {
    coordinates {
      lat
      lng
    }
    officerLevel
    userId
    updatedAt
    displayName
    serviceProviderId
    status
    role
    respondingTo {
      instanceId
      propertyId
    }
    isDeleted
    inRange
  }
}
`;